<template>
    <div class="locale-font">
        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                persistent
                max-width="450">
                <v-card>
                    <div class="modal-close-btn">
                        <div class="cross-style" @click="closeModal()">
                            x
                        </div>
                    </div>
                    <div class="modal-content">
                        <v-card-title class="content-center">
                            <span
                                class="headline">
                                {{ $vuetify.lang.t('$vuetify.assignDeviceModal.assignLocation') }}
                            </span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <div class="text-content mb-3 locale-font">
                                    {{ bureauName }}
                                </div>
                                <div class="text-selected mb-3 locale-font">
                                    {{ $vuetify.lang.t('$vuetify.assignDeviceModal.selected') }} ({{ countSelected }}/{{ countAllDevices }})
                                </div>
                                <div>
                                    <div class="search-input mb-3">
                                        <v-text-field
                                            v-model="search"
                                            prepend-inner-icon="search"
                                            :placeholder="this.$vuetify.lang.t('$vuetify.assignDeviceModal.locationName')"
                                            outlined
                                            hide-details
                                            height="32px"
                                            dense
                                            @keyup.enter="searchDevice()">
                                        </v-text-field>
                                    </div>
                                </div>
                                <div class="select-devices">
                                    <div v-for="device in devicesForm" :key="device.id">
                                        <label
                                            class="mb-3">
                                            <input
                                            type="checkbox"
                                            class="checkbox"
                                            :value="device.value"
                                            v-model="deviceSelected">
                                            {{ device.text }}
                                        </label>
                                    </div>
                                </div>
                            </v-container>
                        </v-card-text>
                    </div>
                    <div class="modal-save-btn">
                        <v-btn
                            color="primary"
                            width="50%"
                            @click="confirm()">
                            {{ $vuetify.lang.t('$vuetify.assignDeviceModal.confirm') }}
                        </v-btn>
                    </div>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'AssignDeviceModal',
    props: {
        bureauId: {
            type: Number,
            default: null
        },
        bureauName: {
            type: String,
            default: null
        }
    },
    computed: {
        countSelected () {
            return this.deviceSelected.length
        }
    },
    data () {
        return {
            dialog: false,
            search: '',
            deviceList: [],
            devicesForm: [],
            deviceSelected: [],
            countAllDevices: 0
        }
    },

    methods: {
        searchDevice () {
            this.devicesForm = this.deviceList.filter(device => device.text.includes(this.search))
        },

        closeModal () {
            this.clearForm()
            this.dialog = false
        },

        clearForm () {
            this.search = ''
            this.deviceList = []
            this.devicesForm = []
            this.deviceSelected = []
        },

        errorNotify (msg) {
            this.$notify({
                title: this.$vuetify.lang.t('$vuetify.assignDeviceModal.errorMessage'),
                text: msg,
                type: 'notify-error'
            })
        },

        async getDeviceSelected () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.get(`device-management/selected/${this.bureauId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.deviceSelected = res.data.data
                this.$store.dispatch('setLoading', false)
            } else if (res && res.data && res.data.status === 'error') {
                this.errorNotify(res.data.msg)
                this.$store.dispatch('setLoading', false)
            }
        },

        async getAllDevices () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.get('device/options')
            if (res && res.data && res.data.status === 'ok') {
                this.deviceList = res.data.data
                this.deviceList.shift()
                this.devicesForm = this.deviceList
                this.countAllDevices = this.deviceList.length
                this.$store.dispatch('setLoading', false)
            } else if (res && res.data && res.data.status === 'error') {
                this.errorNotify(res.data.msg)
                this.$store.dispatch('setLoading', false)
            }
        },

        async confirm () {
            const form = {
                org_id: this.bureauId,
                device_ids: this.deviceSelected
            }

            this.$store.dispatch('setLoading', true)
            const res = await this.axios.post('device-management/assign', form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('assigned', this.bureauName)
                this.dialog = false
                this.$store.dispatch('setLoading', false)
            } else if (res && res.data && res.data.status === 'error') {
                this.errorNotify(res.data.msg)
                this.$store.dispatch('setLoading', false)
            }
        }
    },

    watch: {
        dialog: {
            async handler () {
                if (this.dialog) {
                    await this.getAllDevices()
                    await this.getDeviceSelected()
                }
            },
            deep: true
        },

        search: {
            async handler () {
                this.searchDevice()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.search-input {
    width: 100%;
}
.content-center {
    display: flex;
    justify-content: center;
}
.text-content {
    font-size: 18px;
    font-family: LexendDeca !important;
}
.text-selected {
    font-size: 16px;
    font-family: LexendDeca !important;
}
.select-devices {
    height: 140px;
    overflow: auto;
    padding: 1rem 0.5rem;
    border: 1px solid #c7c7c7;
    border-radius: 4px;
}
.select-devices .checkbox {
    accent-color: #d76436;
    width: 30px;
    height: 15px;
}
.select-devices label {
    display: block;
    font-size: 16px;
}
</style>
